import isMobile from 'ismobilejs'


const styles = (theme)=> ({
      modal: {
        "& .MuiPaper-root" :{
          maxHeight:'90%',
          width:'90%'
        }
      },
      container: {
        overflowX: 'hidden'
      },
      paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop:'65px'
      },
      divider:{
        margin:'3px 0px 16px 0px'
      },
      titulo:{
        fontSize: '20px',
        fontWeight: '700',
        margin: '18px 0 18px 0'
      },
      buttonOutlined : {
        border: '1px solid rgba(0, 0, 0, 0.23)'
      },
      avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
      },
      form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
      },
      submit: {
        margin: theme.spacing(3, 0, 2),
      },
      aaLoaderModal: {
        height: isMobile.any ? '100vh' : '70vh' ,
        width: isMobile.any ? '100%' : '350px',
        display: 'grid',
        justifyContent: 'center',
        alignContent: 'center'
      },
      aaLoader: {
        height: '100vh',
        display: 'grid',
        justifyContent: 'center',
        alignContent: 'center'
      },
      backIcon: {
        position: 'absolute',
        left: 8,
        top: 8,
        color: "#000000DE"
      },
      containerIcon:{
        width: '400px',
        color: '#000000DE'
      },
      helpLink:{
        marginTop:'16px'
      },
})

export default styles